import { useParams, useNavigate } from "react-router-dom";
import { useEffect, useState } from "react";
import SiteHeader from "@/components/feature/SiteHeader";
import SiteFooter from "@/components/feature/SiteFooter";
import { products } from "@/mocks/products";
import ProductDetailHero from "./components/ProductDetailHero";
import ProductDetailInfo from "./components/ProductDetailInfo";
import ProductDetailReviews from "./components/ProductDetailReviews";
import ProductDetailRelated from "./components/ProductDetailRelated";

export default function ProductDetailPage() {
  const { id } = useParams<{ id: string }>();
  const navigate = useNavigate();
  const [product, setProduct] = useState(products.find((p) => p.id === id));

  useEffect(() => {
    const found = products.find((p) => p.id === id);
    if (!found) {
      navigate("/products");
      return;
    }
    setProduct(found);
    window.scrollTo({ top: 0, behavior: "smooth" });
  }, [id, navigate]);

  if (!product) return null;

  return (
    <main className="min-h-screen bg-white">
      <SiteHeader />
      <ProductDetailHero product={product} />
      <ProductDetailInfo product={product} />
      <ProductDetailReviews product={product} />
      <ProductDetailRelated product={product} />
      <SiteFooter />
    </main>
  );
}
